import gql from 'graphql-tag';

export const GET_ORGANIZATION_IMAGES_QUERY = gql`
  query getOrganizationImages(
    $imageType: [ImageTypeEnum!]
    $organizationRevvUid: String
    $limit: Int
    $sort: SortDirectionEnum
    $sort_by: ImageSortByEnum
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        images(filters: { imageType: $imageType, limit: $limit, sort: $sort, sortBy: $sort_by }) {
          results {
            id
            imageFileName
            created_at
            originalUrl
            thumbnailUrl
          }
        }
      }
    }
  }
`;

export const GET_ORGANIZATION_IMAGES_WITH_ASSIGNED_COUNT_QUERY = gql`
  query getOrganizationImagesWithAssignedCount(
    $imageType: [ImageTypeEnum!]
    $organizationRevvUid: String
    $limit: Int
    $sort: SortDirectionEnum
    $sort_by: ImageSortByEnum
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        images(filters: { imageType: $imageType, limit: $limit, sort: $sort, sortBy: $sort_by }) {
          results {
            id
            imageFileName
            created_at
            originalUrl
            thumbnailUrl
            assignedImagesCount
          }
        }
      }
    }
  }
`;

export const UPLOAD_ORGANIZATION_IMAGE_MUTATION = gql`
  mutation uploadOrganizationImageMutation(
    $newImage: File!
    $organizationRevvUid: String!
    $imageType: ImageTypeEnum!
  ) {
    organizationUploadImage(
      organizationRevvUid: $organizationRevvUid
      image: { imageType: $imageType, image: $newImage }
    ) {
      image {
        id
        imageFileName
        created_at
        originalUrl
        thumbnailUrl
        assignedImages {
          id
          created_at
          imageAssignableType
          imageAssignableId
        }
      }
      errors
    }
  }
`;
